import React from "react";

const HomeIcon = () => (
  <svg className="icon" width="22" height="24" xmlns="http://www.w3.org/2000/svg">
    <path d="M.304 7.981A.801.801 0 0 0 0 8.61v14.608c0 .41.366.783.767.783h6.907c.402 0 .768-.373.768-.783v-6h5.116v6c0 .41.366.783.768.783h6.907c.401 0 .767-.373.767-.783V8.61a.805.805 0 0 0-.304-.628L11.464.155c-.335-.217-.628-.196-.928 0L.304 7.981z" fill="#FAD205" fillRule="nonzero"/>
  </svg>
);

export default HomeIcon;